import type { CredentialSummaryResponse } from '@erp/rpc';
import { SelectItem } from 'src/components/ui/select';

/**
 * The saved-password-credential options for a `<Select>`, labelled `name (masked username)`.
 *
 * Rendered identically wherever a saved credential is picked — the agent Tools tab, the browser
 * workflow node, and both Azure AD / VM pickers on the remote-desktop login fields — so it lives
 * here instead of being restated at each site. Emits only the `<SelectItem>`s; the caller owns the
 * `<Select>`, its trigger, and any "none" option, since those differ per site.
 */
export function PasswordCredentialOptions({
  credentials,
}: {
  credentials: CredentialSummaryResponse[];
}) {
  return (
    <>
      {credentials.map((cred) => (
        <SelectItem key={cred.id} value={cred.id}>
          {cred.name}
          {cred.usernameMasked ? ` (${cred.usernameMasked})` : ''}
        </SelectItem>
      ))}
    </>
  );
}
